import {TOKENS} from '../../tokens'

export const menu = {
  dark: {
    icon: {
      color: TOKENS.dark.positive_700,
      color_disabled: TOKENS.dark.contrast_400,
    },
  },
  light: {
    icon: {
      color: TOKENS.light.positive_700,
      color_disabled: TOKENS.light.contrast_400,
    },
  },
} as const
